var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRaisedHand = function SvgRaisedHand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 31 38"
  }), _image || (_image = /*#__PURE__*/React.createElement("image", {
    "data-name": "Vector Smart Object",
    width: 31,
    height: 38,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAmCAYAAAA820BcAAAA/klEQVRYhe3YPUpDURCG4fcTl5AqdlmIIsFCu6R3AW7EHQipDSTaCoKkiGBnIVhYWIudNlEIUZJMGDB6ES3vTHO+7swpHu6c+zNcmdkpcEh8zh23BNgz30iCPcdZV96TdJSBD/0ek7SIxi+BrqRPX0TiN8C+pOm6EIXfAW1Jk2oxAn8EtiW9/N6o+1F7Avb+giPwE0nP/23W3fYl0JF0kYF7PoADSeMM3PP+dfa3GbjnFdiV9LAuRH5YGsCVmbUycM8WMDKzJsFtr8Zbv5M5TIwz8dlmZfEGXAfB/vI5w35yHwR/J3OGK3jBC17wghe8Pjx8qHC87/9HgEGoDKwALYtx5jWQBBUAAAAASUVORK5CYII="
  })));
};
export default SvgRaisedHand;